<template>
  <div class="order">
    <div class="content address_content" @click="goaddress">
      <p class="address_name">
        <span>{{ address.nickname }}</span>
        <span>{{ address.phone }}</span>
      </p>
      <p class="address_add">
        {{ getArea(address.area) }}&nbsp;{{ address.address }}
      </p>
    </div>
    <div class="content pharmacy_content">
      <p class="content_title">发货药房</p>
      <div class="pharmacy_content2" :style="{backgroundImage:'url('+listData.prescription.logo_url+')'}">
        <p class="pharmacy_p1">
          <span>{{ listData.prescription ? listData.prescription.prescription_type_str : '' }}</span>
          ·由{{ listData.prescription ? listData.prescription.name : '' }}提供
          <ins></ins>
        </p>
        <p class="pharmacy_p2">{{ listData.prescription ? listData.prescription.summary : '' }}</p>
        <p class="pharmacy_p2">{{ listData.prescription ? listData.prescription.tags : '' }}</p>
        <div class="decocting_chiose" v-if="isprovide">
          <p
            :class="[{ diy_active: !isdecocting }, 'chiose_p chiose_p1']"
            @click="daijian(1)"
          >
            自己煎煮
          </p>
          <!--          <p-->
          <!--            v-if="candecocting"-->
          <!--            :class="[{ diy_active: isdecocting }, 'chiose_p chiose_p2']"-->
          <!--            @click="daijian(2)"-->
          <!--          >-->
          <!--            代煎&nbsp;{{listData.prescription?listData.prescription.over_fee:'3.00'}}元/帖-->
          <!--          </p>-->
          <p class="chiose_p">暂不支持代煎</p>
        </div>
      </div>
    </div>
    <div class="content distribution_content" @click="show_express = true">
      <p class="content_title">
        配送
        <span class="distribution_p1">{{
            distribution[export_index].name
          }}</span>
      </p>
      <p class="distribution_p2">{{ distribution[export_index].details }}</p>
    </div>
    <div class="content prescription_content">
      <div class="personal" v-if="listData.name!=''&&listData.sex!=''&&listData.age!=''">
        <p>患者：{{ listData.name }}</p>
        <p>
          性别：
          <span v-if="listData.sex == 0">女</span>
          <span v-else>男</span>
        </p>
        <p>年龄：{{ listData.age }}岁</p>
      </div>
      <div class="content2" v-if="listData.diseases">
        <p class="head_title">诊断</p>
        <p class="content_details">{{ listData.diseases }}{{
            listData.diseases && listData.symptons ? '·' : ''
          }}{{ listData.symptons }}</p>
      </div>
      <div class="content2">
        <p class="head_title">
          <span>{{ listData.prescription ? listData.prescription.prescription_type_str : '' }}</span>
          {{ listData.prescription ? listData.prescription.name : '' }}（共{{
            listData.prescription ? listData.prescription.content.length > 0 ? listData.prescription.content.length : 0 : 0
          }}味药）
        </p>
        <p class="content_details" v-if="listData.prescription?listData.prescription.show_type == 1:false">
          <span
            class="medicament_li"
            v-for="(item, index) in listData.prescription.content.length>0?listData.prescription.content:[]"
            :key="index"
          >{{ item.name }}&nbsp;{{ item.count }}{{
              item.unit ? item.unit : 'g'
            }}{{ item.usage ? '(' + item.usage + ')' : '' }}</span
          >
        </p>
        <p
          v-else-if="listData.prescription?listData.prescription.show_type == 2:false"
          class="medicament_li_tips1 medicament_li_tips2"
        >
          购买后即可查看完整药方
        </p>
        <p
          class="content_details"
          v-else-if="listData.prescription?listData.prescription.show_type == 3:false"
        >
          <span
            class="medicament_li"
            v-for="(item, index) in listData.prescription.content.length>0?listData.prescription.content:[]"
            :key="index"
          >{{ item.name }}&nbsp;</span>
        </p>
        <p class="content_details" v-if="listData.prescription?listData.prescription.text_show_type != 3:false">
          帖数：共{{ listData.prescription ? listData.prescription.total_count : '' }}帖
        </p>
      </div>
      <div class="content2">
        <p class="head_title">用法</p>
        <p class="content_details" v-if="listData.prescription?listData.prescription.text_show_type == 1:''">
          内服;共{{
            listData.prescription ? listData.prescription.total_count : ''
          }}帖,每日{{
            listData.prescription ? listData.prescription.one_day_count : ''
          }}帖,每帖分{{ listData.prescription ? listData.prescription.once : '' }}次服用
        </p>
        <p class="content_details" v-if="listData.prescription?listData.prescription.text_show_type == 2:''">
          外用;共{{
            listData.prescription ? listData.prescription.total_count : ''
          }}帖,每日{{
            listData.prescription ? listData.prescription.one_day_count : ''
          }}帖,每帖分{{ listData.prescription ? listData.prescription.once : '' }}次使用
        </p>
        <p class="content_details" v-if="listData.prescription?listData.prescription.text_show_type == 3:''">
          每日{{
            listData.prescription ? listData.prescription.one_day_count : ''
          }}次,每次{{
            listData.prescription ? listData.prescription.once : ''
          }}g,预计可用{{ listData.prescription ? listData.prescription.use_days : '' }}天
        </p>
      </div>
      <div class="content2 bn">
        <p class="head_title">
          医嘱
          <span class="ask" v-show="is_app && is_Patient" @click="askdoctor">咨询医生</span>
        </p>
        <p class="content_details">{{ listData.prescription ? listData.prescription.advice : '' }}</p>
      </div>
    </div>
    <div class="content charging_content">
      <p class="charging_p1">
        药费
        <span>￥{{ charging.drug_fee ? Number(charging.drug_fee).toFixed(2) : '' }}</span>
      </p>
      <p class="charging_p1">
        加工费
        <span>￥{{ isdecocting ? jiagongfei : 0 }}</span>
      </p>
      <p class="charging_p1">
        诊金
        <span>￥{{ charging.diagnosis_fee ? charging.diagnosis_fee : '0' }}</span>
      </p>
      <p class="charging_p1">
        运费（满百包邮）
        <span :class="charging.express_fee > 100 ? 'del_active' : ''"
        >￥{{ charging.express_fee }}</span
        >
      </p>
      <p class="charging_p1">
        优惠券
        <span
          v-show="is_choise_coupon == 1"
          class="coupon_count"
          @click="change_coupon"
        >{{ coupon_count }}张可用</span>
        <span v-show="is_choise_coupon == 2">￥{{ charging.discount }}</span>
        <span v-show="is_choise_coupon == 3" class="no_coupon"
        >无优惠券可用</span
        >
      </p>
      <p class="charging_p2">
        合计
        <span>￥{{ Number(total_fee).toFixed(2) }}</span>
      </p>
    </div>
    <div class="content order_content">
      <p class="dorctor_name">医生：{{ listData.prescription ? listData.prescription.doctor_name : '' }}</p>
      <p class="dorctor_time">开方时间：{{ distance(listData.created_at) }}</p>
    </div>
    <div class="content order_content">
      <p class="dorctor_name"><span style="font-weight: bold;color: #ac4838">温馨提示：由于药品的特殊性，除质量原因外，售出后不支持退款！</span></p>
    </div>
    <div class="submit_content">
      <button class="buynow" @click="gopay">立即支付</button>
    </div>
    <van-popup
      class="express_content"
      v-model="show_express"
      position="bottom"
      round
      :style="{ height: '30%' }"
    >
      <p class="express_head">
        <span class="express_cancel" @click="show_express = false">取消</span>
        选择配送方式
        <span
          class="express_determine"
          @click="
            (export_index = pre_export_index),
              (show_express = false),
              getmoney()
          "
        >确定</span>
      </p>
      <ul class="express_ul">
        <li
          v-for="(item, index) in distribution"
          :key="index"
          class="express_li"
          @click="pre_export_index = index"
        >
          <img
            :src="require('../../assets/images/order/icon' + index + '.png')"
            alt
          />
          <p>
            {{ item.name }}
            <br/>
            <span>{{ item.details }}</span>
          </p>
          <div
            :class="[
              { express_icon_active: index == pre_export_index },
              'express_icon',
            ]"
          ></div>
        </li>
      </ul>
    </van-popup>
    <!-- 支付选择弹窗 -->
    <van-popup
      class="express_content"
      v-model="show_pay"
      position="bottom"
      round
      :style="{ height: '85%' }"
    >
      <p class="express_head">
        <span class="express_cancel" @click="show_pay = false">取消</span>
        选择支付方式
        <!-- <span class="express_determine" @click="export_index=pre_export_index,show_pay=false,getmoney()">确定</span> -->
      </p>
      <ul class="express_ul">
        <li
          v-for="(item, index) in payment"
          :key="index"
          class="express_li"
          @click="pre_pay_index = index"
          v-show="item.isshow"
        >
          <img
            :src="
              require('../../assets/images/order/pay_icon' + index + '.png')
            "
            alt
          />
          <p class="pay_p">{{ item.name }}</p>
          <div
            :class="[
              { express_icon_active: index == pre_pay_index },
              'express_icon',
            ]"
          ></div>
        </li>
      </ul>
      <button class="buynow" @click="orderup">确认</button>
    </van-popup>
    <Loading :value="show"/>
  </div>
</template>
<script>
import {deviceType} from '../../util/deviceType'
import wx from 'weixin-jsapi'
import http from '../../util/pontusApiConfig'
import http2 from '../../util/gaeaApiConfig'
import http3 from '../../util/iapetusApiConfig'
import http4 from '../../util/dorisApiConfig'
import {parse} from 'semver'
import Loading from '../loading/loading'

import VConsole from 'vconsole'

export default {
  components: {
    Loading
  },
  data () {
    return {
      user_id: '',
      show: true,
      listData: {},
      address: {},
      pharmacy: {
        name: '北京·康美药业',
        detail: '专业从事中药配方颗粒研究和生产15年',
        tips: '17:00前下单，当日寄出'
      },
      show_express: false,
      export_index: 0,
      pre_export_index: 0,
      distribution: [
        {
          name: '顺丰快递',
          details: '药费满¥100包邮，90%地区次日送达',
          money: 0
        }
      ],
      show_pay: false,
      pre_pay_index: 0,
      payment: [
        {
          name: '支付宝支付',
          isshow: true
        },
        {
          name: '微信支付',
          isshow: true
        }
      ],
      // 是否提供代煎选择
      isprovide: true,
      // 是否代煎
      isdecocting: false,
      jiagongfei: 0,
      total_fee: 0,
      // 可以代煎
      candecocting: false,
      amountOfMoney: 0,
      charging: {
        // 药费
        drugcost: 0,
        // 运费
        freight: 15,
        // 优惠费
        discount: 0,
        // 代煎费
        decoctingfee: 0
      },
      is_choise_coupon: 3,
      coupon_count: 0,
      // 供应商id
      provider_id: null,
      order_id: 2,
      openid: this.$route.query.openid,
      token: '',
      appid: 'wxaad7ad4759a50bb1',
      is_weixin: deviceType.isWeiXin,
      is_app: deviceType.isApp,
      is_ios_app: deviceType.isIOSApp,
      is_android_app: deviceType.isAndroidApp,
      is_Patient: deviceType.isPatient,
      diagnosis_prescription_id: null,
      prescription_id: null,
      platform_type: 1,
      isApp: '',
      doctor_user_id: '',
      is_mini: false,
      addressName: ''
    }
  },
  created () {
    let bridge = window.WebViewJavascriptBridge
    this.isApp = this.$appUtils.isApp()
    if (this.isApp == 'IOS') {
      bridge.callHandler('getUserInfo', '', response => {
        this.user_id = response.user_id
        this.token = response.token
      })
    } else if (this.isApp == 'android') {
      var user_info = this.$appUtils.appData()
      if (user_info) {
        this.user_id = user_info.user_id
        this.token = user_info.token
      }
    } else if (this.$route.query.is_mini != 'false' && this.$route.query.is_mini != '') {
      this.token = this.$route.query.token
      this.user_id = this.$route.query.user_id
      this.doctor_user_id = this.$route.query.doctor_user_id
      this.is_mini = true
      this.platform_type = '1'
      console.log(this.token, this.user_id, this.doctor_user_id)
    } else {
      this.user_id = localStorage.getItem('user_id')
      this.token = localStorage.getItem('token')
      this.platform_type = '1'
    }
    this.diagnosis_prescription_id = this.$route.query.diagnosis_prescription_id
    this.prescription_id = this.$route.query.prescription_id
    if (localStorage.getItem('openid')) {
      this.openid = localStorage.getItem('openid')
    }
    if (this.is_weixin) {
      this.payment[0].isshow = false
    }
    if (!this.is_mini) {
      if (this.is_weixin && !this.openid) {
        let code = this.$route.query.code
        if (code) {
          this.getOpenid(code)
        } else {
          let redirectUrl = window.location.href + '&type=true'
          redirectUrl = encodeURIComponent(redirectUrl)
          let url =
            'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
            this.appid +
            '&redirect_uri=' +
            redirectUrl +
            '&response_type=code&scope=snsapi_userinfo&state=type%wechat_redirect'
          window.location.href = url
        }
      }
      setTimeout(() => {
        this.getinit()
        if (localStorage.getItem('address_id')) {
          this.getaddress()
        } else {
          this.getdefault_address()
        }
      }, 1000)

      window.appBack = () => this.pageback()
    }
  },
  mounted () {
  },
  methods: {
    askdoctor () {
      let bridge = window.WebViewJavascriptBridge
      this.isApp = this.$appUtils.isApp()
      if (this.isApp == 'IOS') {
        bridge.callHandler('closeWebView', '', response => {
        })
      } else if (this.isApp == 'android') {
        this.$appUtils.appCloseWebView()
      }
    }
    ,
    getinit () {
      let that = this
      let url = ''
      if (deviceType.isDoctor) {
        url =
          'studio/doctors/' +
          this.doctor_id +
          '/diagnosis_prescriptions/' +
          this.diagnosis_prescription_id
      } else {
        url = '/diagnosis_prescriptions/' + this.diagnosis_prescription_id
      }
      http3
        .get(url, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: this.token
          }
        })
        .then(function (res) {
          if (res.data.status_code == 200) {
            that.show = false
            that.listData = res.data.data
            console.log(that.listData.prescription.type)
            if (that.listData.prescription.type == 2) {
              that.candecocting = true
              that.isdecocting = false
            } else {
              that.candecocting = false
              that.isdecocting = false
            }
            that.listData.prescription.content = JSON.parse(
              that.listData.prescription.content
            )
            that.getmoney()
            that.$appUtils.appCloseLoadingView()
          } else if (res.data.status_code == 10000) {
            that.$router.push({
              path: '/order_login',
              query: {
                diagnosis_prescription_id:
                that.$route.query.diagnosis_prescription_id
              }
            })
          }
        })
    }
    ,
    getArea (arr) {
      let str = ''
      if (arr) {
        arr = JSON.parse(arr)
        for (let i = 0; i < arr.length; i++) {
          if (i == 0) {
            str = arr[i]['name']
          } else {
            str = str + ' ' + arr[i]['name']
          }
          if (i == 1) {
            if (
              arr[i].id == 230 &&
              arr[i].code == '440100' &&
              arr[i].name == '广州市'
            ) {
              this.distribution[0].money = 10
              this.charging.freight = 10
            } else {
              this.distribution[0].money = 20
              this.charging.freight = 20
            }
          }
        }
      }
      return str
    }
    ,
    getaddress (num) {
      let that = this
      http2
        .get('/users/' + that.user_id + '/addresses', {
          headers: {
            Authorization: that.token
          }
        })
        .then(function (res) {
          if (res.data.status_code == 200) {
            for (let i = 0; i < res.data.data.addresses.length; i++) {
              if (
                res.data.data.addresses[i].address_id ==
                localStorage.getItem('address_id')
              ) {
                that.address = res.data.data.addresses[i]
                break
              }
            }
            if (num == 1 && JSON.stringify(that.address) == '{}') {
              for (let i = 0; i < res.data.data.addresses.length; i++) {
                if (res.data.data.addresses[i].is_default == 2) {
                  that.address = res.data.data.addresses[i]
                }
              }

            }
            if (that.address) {
              that.addressName = JSON.parse(that.address.area)[0].name
            }
            http4
              .get(
                'drugs/calculation_express_fee/' +
                that.prescription_id +
                '?address=' +
                that.addressName,
                {
                  headers: {
                    Authorization: that.token
                  }
                }
              )
              .then(res => {
                if (res.data.status_code == 200) {
                  that.charging = res.data.data
                  that.jiagongfei = that.charging.processing_fee ? Number(that.charging.processing_fee).toFixed(2) : ''
                  let total = that.charging.total_fee ? Number(that.charging.total_fee).toFixed(2) : ''
                  if (that.isdecocting) {
                    that.total_fee = Number(total) + Number(that.jiagongfei)
                  } else {
                    that.total_fee = Number(total)
                  }
                }
              })
          }
        })
    }
    ,
    getdefault_address () {
      http2
        .get(
          '/users/' +
          this.user_id +
          '/default_address?platform_type=' +
          this.platform_type,
          {
            headers: {
              Authorization: this.token
            }
          }
        )
        .then(res => {
          if (res.data.status_code == 200) {
            if (res.data.data.address) {
              this.addressName = JSON.parse(res.data.data.area)[0].name
            }
            http4
              .get(
                'drugs/calculation_express_fee/' +
                this.prescription_id +
                '?address=' +
                this.addressName,
                {
                  headers: {
                    Authorization: this.token
                  }
                }
              )
              .then(res => {
                if (res.data.status_code == 200) {
                  this.charging = res.data.data
                  this.jiagongfei = this.charging.processing_fee ? Number(this.charging.processing_fee).toFixed(2) : ''
                  let total = this.charging.total_fee ? Number(this.charging.total_fee).toFixed(2) : ''
                  if (this.isdecocting) {
                    this.total_fee = Number(total) + Number(this.jiagongfei)

                  } else {
                    this.total_fee = Number(total)
                  }
                }
              })
            if (JSON.stringify(this.address) == '{}') {
              this.getaddress(1)
            }
          }
        })
    }
    ,
    daijian (type) {
      let total = 0
      if (type == 2) {
        this.isdecocting = true
        this.jiagongfei = this.charging.processing_fee ? Number(this.charging.processing_fee).toFixed(2) : ''
        total = this.charging.total_fee ? Number(this.charging.total_fee).toFixed(2) : ''
        this.total_fee = Number(total) + Number(this.jiagongfei)
      } else {
        this.isdecocting = false
        this.jiagongfei = 0
        this.total_fee = this.charging.total_fee ? Number(this.charging.total_fee).toFixed(2) : ''
      }
    }
    ,
    getData () {
      let that = this
      let iss = true
      if (iss) {
        this.candecocting = true
        this.isdecocting = false
      } else {
        this.candecocting = false
        this.isdecocting = false
      }
      let iss2 = this.is_choise_coupon
      if (iss2 == 1) {
        this.coupon_count = 4
        this.charging.discount = 0
      } else if (iss2 == 2) {
        this.coupon_count = 0
        this.charging.discount = 20
      } else {
        this.coupon_count = 0
        this.charging.discount = 0
      }
      this.pre_export_index = this.export_index
      this.getmoney()
      // this.choise_coupon()
    }
    ,
    goaddress () {

      this.$router.push({
        path: 'addresslist',
        query: {
          t: 1,
          token: this.token,
          user_id: this.user_id,
          doctor_user_id: this.$route.query.doctor_user_id,
          is_mini: true,
          platform_type: '1',
        }
      })
    }
    ,
    getmoney () {
      let money = this.charging.drugcost
      this.charging.freight = this.distribution[this.export_index].money

      // 满百免邮
      if (this.charging.drugcost < 100) {
        money += this.charging.freight
      }
      // 优惠减价
      if (this.charging.discount > 0) {
        money -= this.charging.discount
      }
      this.amountOfMoney = money
    }
    ,
    // 选择优惠券
    change_coupon () {
      this.$router.push({
        path: '/coupon',
        query: {
          provider_id: this.listData.prescription.provider_id,
          money: this.charging.drugcost
        }
      })
    }
    ,
    distance (day) {
      //过去的时间戳
      var now = new Date(day * 1000) //过去 //年
      var year = now.getFullYear() //月
      var month = now.getMonth() + 1 //日
      var date = now.getDate() //时
      var hour = now.getHours() //分
      var minute = now.getMinutes() //秒
      var second = now.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      if (hour < 10) {
        hour = '0' + hour
      }
      if (minute < 10) {
        minute = '0' + minute
      }
      if (second < 10) {
        second = '0' + second
      }
      var timer =
        year +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second

      return timer
    }
    ,
    getOpenid (code) {
      let that = this
      let params = {code: code, platform_type: 1, wx_type: 1}
      http2.get('/users/oauth/user', {params: params}).then(function (res) {
        if (res.data.status_code == 200) {
          that.openid = res.data.data.openid
          localStorage.setItem('openid', that.openid)
        }
      })
    }
    ,
    gopay () {
      if (this.charging.express_fee) {
        this.show_pay = true
      } else {
        this.$dialog.alert({
          message: '请您填写收货地址',
        })
        return false
      }
    }
    ,
    orderup () {
      let that = this
      let area = this.getArea(this.address.area) + ' ' + this.address.address
      console.log(that.openid)
      let params = {
        order_type: 'prescription',
        prescription_id: this.$route.query.diagnosis_prescription_id,
        coupon_type: this.coupon_type || '',
        receive_coupon_id: this.coupon_id || '',
        address: area,
        addressee: this.address.nickname,
        phone: this.address.phone,
        postage: this.charging.express_fee,
        //postage: 0,
        return_url: window.location.origin + '/orderresult',
        platform_type: '1',
        is_process: this.isdecocting == true ? 1 : 2
      }
      console.log(params, 'daijian')
      if (this.is_ios_app) {
        params['channel'] = 'ios'
      } else if (this.is_android_app) {
        params['channel'] = 'android'
      } else {
        params['channel'] = 'wap'
      }
      if (this.is_app) {
        if (this.pre_pay_index == 0) {
          params['scene'] = 1
          params['pay_type'] = 'ali_app'
        } else {
          params['scene'] = 0
          params['pay_type'] = 'wx_app'
        }
        params['return_url'] =
          window.location.origin +
          '/order_detail?diagnosis_prescription_id=' +
          params.prescription_id
        let bridge = window.WebViewJavascriptBridge
        that.isApp = that.$appUtils.isApp()
        if (that.isApp == 'IOS') {
          bridge.callHandler('pay', {params: params}, response => {
          })
        } else if (that.isApp == 'android') {
          that.$appUtils.appPay(params)
        }
      } else {
        if (this.pre_pay_index == 0) {
          params['pay_type'] = 'ali_wap'
        } else {
          if (this.is_weixin) {
            params['pay_type'] = 'wx_js'
            params['openid'] = this.openid
          } else {
            params['pay_type'] = 'wx_h5_wap'
          }
        }
        this.toPay(params)
      }
      this.show_pay = false
    }
    ,
    toPay (params) {
      let that = this
      http
        .post('/users/' + that.user_id + '/order', params, {
          headers: {Authorization: that.token}
        })
        .then(function (res) {
          if (res.data.status_code == 200) {
            localStorage.setItem('out_trade_no', res.data.data.out_trade_no)
            if (params['pay_type'] == 'ali_wap') {
              window.location.href = res.data.data.pay_params
            } else if (params['pay_type'] == 'wx_h5_wap') {
              window.location.href =
                res.data.data.pay_params.mweb_url +
                '&redirect_url=' +
                params['return_url']
            } else if (params['pay_type'] == 'wx_js') {
              if (typeof WeixinJSBridge == 'undefined') {
                if (document.addEventListener) {
                  document.addEventListener(
                    'WeixinJSBridgeReady',
                    that.onBridgeReady(res.data.data.pay_params),
                    false
                  )
                } else if (document.attachEvent) {
                  document.attachEvent(
                    'WeixinJSBridgeReady',
                    that.onBridgeReady(res.data.data.pay_params)
                  )
                  document.attachEvent(
                    'onWeixinJSBridgeReady',
                    that.onBridgeReady(res.data.data.pay_params)
                  )
                }
              } else {
                that.onBridgeReady(res.data.data.pay_params)
              }
            }
          }
        })
    }
    ,
    onBridgeReady (data) {
      let that = this
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: data.appid, // 公众号名称，由商户传入
          timeStamp: data.timestamp, // 时间戳，自1970年以来的秒数
          nonceStr: data.noncestr, // 随机串
          package: data.package,
          signType: data.signtype, // 微信签名方式：
          paySign: data.sign // 微信签名
        },
        function (res) {
          // alert(JSON.stringify(res));
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            window.location.href = window.location.origin + '/orderresult'
          }
        }
      )
    }
    ,
    pageback () {
      window.history.back()
      return
    }
  }
  ,
  watch: {
    isdecocting (val) {
      this.getmoney()
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  padding-top: 10px;

  .content {
    width: calc(100% - 30px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 10px;
    margin: 0 auto;
    margin-bottom: 10px;
    color: #333;

    .content_title {
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;

      .distribution_p1 {
        font-size: 14px;
        float: right;
        margin-right: 17px;

        &::after {
          content: "";
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-left: 6px;
          background: url("../../assets/images/order/more.png") no-repeat center center;
          background-size: cover;
          vertical-align: text-top;
        }
      }
    }
  }

  .address_content {
    height: 80px;
    padding-left: 60px;
    position: relative;
    background: url("../../assets/images/order/address_icon.png") no-repeat 10px center;
    background-size: 40px 40px;

    p {
      width: 100%;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .address_add {
      color: #666;
    }

    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 16px;
      height: 16px;
      top: calc(50% - 8px);
      right: 5px;
      background: url("../../assets/images/order/more.png") no-repeat center center;
      background-size: cover;
    }
  }

  .pharmacy_content {
    .pharmacy_content2 {
      width: 100%;
      box-sizing: border-box;
      padding-left: 54px;
      margin-top: 10px;
      background-repeat: no-repeat;
      background-size: 44px 44px;

      .pharmacy_p1 {
        font-size: 14px;
        color: #333;

        ins {
          width: 12px;
          height: 12px;
          display: inline-block;
          background: url("../../assets/images/order/i.png") no-repeat center center;
          background-size: cover;
          margin-left: 5px;
        }

        font-weight: 500;
      }

      .pharmacy_p2 {
        font-size: 12px;
        color: #999;
        margin-top: 3px;
      }

      .decocting_chiose {
        display: flex;
        justify-content: space-between;
        margin-top: 9px;

        .chiose_p {
          width: 128px;
          height: 40px;
          line-height: 40px;
          color: #999999;
          font-size: 12px;
          box-shadow: 0px -1px 0px 0px rgba(244, 244, 244, 1);
          border-radius: 8px;
          border: 1px solid rgba(153, 153, 153, 1);
          text-align: center;
        }

        .diy_active {
          border: 1px solid #ac4b38;
          background: #fff2f0;
          color: #ac4b38;
        }

        .diy_active.chiose_p1::before {
          background: url("../../assets/images/order/diy_pre.png") no-repeat center center;
          background-size: cover;
        }

        .diy_active.chiose_p2::before {
          background: url("../../assets/images/order/medicine_pre.png") no-repeat center center;
          background-size: cover;
        }

        .chiose_p1 {
          &::before {
            content: "";
            width: 24px;
            height: 24px;
            display: inline-block;
            background: url("../../assets/images/order/diy_nor.png") no-repeat center center;
            background-size: cover;
            vertical-align: middle;
            margin-right: 12px;
          }
        }

        .chiose_p2 {
          &::before {
            content: "";
            width: 24px;
            height: 24px;
            display: inline-block;
            background: url("../../assets/images/order/medicine_nor.png") no-repeat center center;
            background-size: cover;
            vertical-align: middle;
            margin-right: 12px;
          }
        }
      }
    }
  }

  .distribution_content {
    .distribution_p2 {
      font-size: 12px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      text-align: right;
      padding-right: 17px;
    }
  }

  .prescription_content {
    background: url("../../assets/images/order/background_prescription.png") no-repeat top center;
    background-size: 100% 92px;

    .personal {
      height: 92px;
      padding: 37px 10px 14px 10px;
      box-sizing: border-box;
      // background: rgba(255, 242, 242, 1);
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      position: relative;
      border-radius: 8px 8px 0px 0px;

      &::before {
        content: "处方";
        width: 100%;
        display: block;
        text-align: center;
        position: absolute;
        top: 0px;
        font-size: 16px;
      }
    }

    .content2 {
      padding-bottom: 12px;
      border-bottom: 1px solid #fef2f0;

      .head_title {
        width: 100%;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        margin-top: 12px;
        margin-bottom: 6px;

        &::before {
          content: "";
          display: block;
          width: 4px;
          height: 16px;
          background: #de654c;
          position: absolute;
          top: 4px;
          left: -10px;
        }

        .ask {
          float: right;
          padding: 4px 8px;
          border-radius: 4px;
          text-align: center;
          font-size: 12px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #ac4b38;
          line-height: 17px;

          &::before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 15px;
            background: url("../../assets/images/order/msg.png") no-repeat center center;
            background-size: cover;
            vertical-align: text-top;
            margin-right: 5px;
          }
        }
      }

      .content_details {
        font-size: 14px;
        line-height: 21px;
        color: #666;

        .medicament_li {
          display: inline-block;
          margin-right: 6px;
        }
      }

      .medicament_li_tips1 {
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #999999;
        line-height: 25px;
        text-align: center;
      }

      .medicament_li_tips2 {
        padding: 20px 0px;
      }
    }
  }

  .bn {
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }

  .detail_content {
    .detail_p1 {
      font-size: 12px;
      margin-bottom: 10px;
      color: #999999;

      span {
        float: right;
      }
    }
  }

  .charging_content {
    .charging_p1 {
      font-size: 14px;
      margin-bottom: 10px;
      color: #333333;
      margin-bottom: 13px;

      span {
        float: right;
      }

      .del_active {
        text-decoration: line-through;
      }

      .coupon_count {
        color: #ac4b38;

        &::after {
          content: "";
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-left: 2px;
          background: url("../../assets/images/order/more.png") no-repeat center center;
          background-size: cover;
          vertical-align: text-top;
        }
      }

      .no_coupon {
        color: #999;
      }
    }

    .charging_p2 {
      margin-top: 15px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);

      span {
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        float: right;
        color: #ac4b38;
      }
    }
  }

  .order_content {
    .dorctor_name {
      font-size: 14px;
    }

    .dorctor_time {
      margin-top: 14px;
      font-size: 12px;
      color: #999999;
    }
  }

  .submit_content {
    width: 100%;
    height: 70px;
    padding: 10px 15px;
    box-sizing: border-box;
    border-top: 1px solid #e4e4e4;

    .submit_money {
      font-size: 14px;
      line-height: 40px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      display: inline-block;

      span {
        font-weight: bold;
        font-size: 24px;
      }
    }

    .submit_button {
      border: none;
      width: 120px;
      height: 40px;
      background: rgba(172, 75, 56, 1);
      border-radius: 10px;
      text-align: center;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 25px;
      float: right;
    }
  }

  .express_content {
    background-color: #f8f8f8;

    .express_head {
      background-color: #fff;
      width: 100%;
      height: 60px;
      line-height: 60px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
      position: relative;

      .express_cancel,
      .express_determine {
        display: inline-block;
        padding: 0px 15px;
        height: 60px;
        font-size: 14px;
        position: absolute;
        top: 0;
      }

      .express_cancel {
        color: #999;
        left: 0;
      }

      .express_determine {
        color: #ac4b38;
        right: 0;
      }
    }

    .express_ul {
      width: 100%;
      box-sizing: border-box;
      padding: 0px 15px;

      .express_li {
        width: 100%;
        height: 60px;
        border-radius: 8px;
        background: #fff;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 15px 12px;
        display: flex;

        img {
          display: block;
          width: 30px;
          height: 30px;
        }

        p {
          width: calc(100% - 60px);
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          line-height: 16px;
          margin-left: 10px;

          span {
            color: #999;
            font-size: 12px;
          }
        }

        .pay_p {
          line-height: 30px;
        }

        .express_icon {
          width: 20px;
          height: 20px;
          background: url("../../assets/images/order/express_nor.png") no-repeat center center;
          background-size: cover;
          margin-top: 5px;
        }

        .express_icon_active {
          background: url("../../assets/images/order/express_pre.png") no-repeat center center;
          background-size: cover;
        }
      }
    }
  }

  .buynow {
    width: calc(100% - 40px);
    height: 48px;
    background: rgba(172, 75, 56, 1);
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    border: none;
    margin: 0 auto;
  }

  .submit_content .buynow {
    width: 100%;
  }

  .express_content .buynow {
    position: fixed;
    bottom: 10px;
    left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/order.vue